import { Link } from "react-router-dom";
import Badge from "@/components/base/Badge";
import type { Product } from "@/types/content";

interface ProductCardProps {
  product: Product;
  className?: string;
}

export default function ProductCard({ product, className = "" }: ProductCardProps) {
  const to = `/productos/${product.id}`;

  return (
    <div
      data-product-preview
      className={`flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 shadow-soft transition-all duration-200 hover:shadow-card ${className}`}
    >
      <Link to={to} className="block cursor-pointer">
        <div className="relative h-40 w-full overflow-hidden bg-background-100 sm:h-44">
          <img
            src={product.thumbnailImage ?? product.image}
            alt={`${product.name} — ${product.category} ALÉA Skin`}
            title={`${product.name} ALÉA Skin`}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover object-top"
          />
          <span className="absolute left-3 top-3">
            <Badge tone="accent">{product.category}</Badge>
          </span>
          <span className="absolute bottom-3 left-3 rounded-full bg-background-50/90 px-3 py-1 font-label text-[10px] font-bold uppercase tracking-[0.18em] text-primary-700 shadow-soft backdrop-blur">
            {product.statusLabel ?? "Proximamente"}
          </span>
        </div>
      </Link>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <Link to={to} className="cursor-pointer">
          <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 line-clamp-2">
            {product.name}
          </h3>
        </Link>
        <p className="text-xs leading-relaxed text-foreground-600 line-clamp-3">
          {product.benefit}
        </p>
        <Link
          to={to}
          className="mt-auto inline-flex items-center gap-1 pt-2 font-label text-xs font-bold text-accent-700"
        >
          Conocer producto
          <i className="ri-arrow-right-line text-sm leading-none" />
        </Link>
      </div>
    </div>
  );
}


